import React from 'react';
import AccountsStore from '../../stores/AccountsStore';

class StatementPreferenceRowTemplate extends React.Component {
  constructor(props) {
    super(props);
    this._onPaperFreeToggle = this._onPaperFreeToggle.bind(this);
    this._onPaperToggle = this._onPaperToggle.bind(this);
    this.state = {
      showModal: false,
      optOutFlag: this.props.rowData.optOutFlag,
    };
  }

  componentWillMount() {
    this.setState({
      optOutFlag: this.props.rowData.optOutFlag,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      optOutFlag: nextProps.rowData.optOutFlag,
    });
  }

  _onPaperFreeToggle() {
    const booleanValue = true;
    this.setState({ optOutFlag: true });
    this.props._onChangedPreference(this.props.rowData.accountId, booleanValue);
  }

  _onPaperToggle() {
    const booleanValue = false;
    this.setState({ optOutFlag: false });
    this.props._onChangedPreference(this.props.rowData.accountId, booleanValue);
  }

  render() {
    const accDetails = AccountsStore.getAccountDetail(
      this.props.rowData.accountId
    );
    const buttonClassName = this.state.optOutFlag;
    let paperFreeClassName;
    let paperClassName;
    if (buttonClassName) {
      paperFreeClassName = 'selected';
      paperClassName = '';
    } else {
      paperFreeClassName = '';
      paperClassName = 'selected';
    }
    return (
      <div className="preference-row">
        <section>
          <h5>{this.props.rowData.accountName}</h5>
          <span> (ends {accDetails.accountNumber.slice(-4)})</span>
        </section>
        <section>
          <div className="print-options">
            <button
              className={`btn ${paperFreeClassName}`}
              onClick={this._onPaperFreeToggle}
            >
              {this.props.content.paperfree}
            </button>
            <button
              className={`btn ${paperClassName}`}
              onClick={this._onPaperToggle}
            >
              Paper
            </button>
          </div>
        </section>
      </div>
    );
  }
}

export default StatementPreferenceRowTemplate;
